import { IGame, IGamesStore } from '../store';

import api, { request } from '../../../../api';
import { IErrorsStore } from '../../../errors/store';
import { IStore } from '../../../index';

export const getAllGames = async (
  state: IStore,
  force?: boolean
): Promise<{ games?: IGamesStore; errors?: IErrorsStore }> => {
  if (Object.keys(state.games).length && !force) {
    return { games: state.games };
  }

  const response = await request.get(`${api.games}`);

  if (response.error) {
    return { errors: { games: { msg: 'Error retrieving the Games List.' } } };
  }

  const allGames = response.reduce(
    (parsedGames: IGamesStore, rawGame: IGame) => ({
      ...parsedGames,
      [Number(rawGame.id)]: rawGame
    }),
    {}
  );

  return {
    games: {
      ...state.games,
      ...allGames
    }
  };
};
